import TaskHeader from "components/task/header/TaskHeader";
import { Box } from "@mui/joy";
import MyThoughtMapContent from "./MyThoughtMapContent";
import NoticeBannerStatic from "../../common/NoticeBannerStatic";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../../recoil/userAtom";
import useBottomSafePadding from "hooks/useBottomSafePadding";

export default function MyThoughtMap({
  showPaymentModule,
}: {
  showPaymentModule: boolean;
}) {
  const user = useRecoilValue(userAtom);
  // Android in-app 에서 마지막 콘텐츠가 home indicator 에 바로 붙지 않도록
  // breathing 확보. iOS / PC 는 상위 컨테이너에서 env() 로 이미 처리되므로
  // 여기서는 0 반환 → 자연스럽게 중복 없음.
  const bottomPb = useBottomSafePadding("0px");

  return (
    <>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 100,
        }}
      >
        <TaskHeader taskKey={"thoughtmap"} />
        {user?.role === "patient" && (
          <NoticeBannerStatic
            message={"프로그램이 진행되며 자동으로 완성됩니다."}
            type={"thoughtMap"}
          />
        )}
      </Box>

      <div
        className="w-full h-full overflow-x-hidden"
        style={{ paddingBottom: bottomPb }}
      >
        <MyThoughtMapContent />
      </div>
    </>
  );
}
